import axios from 'axios';

// Environment-aware API base URL
const envBase = process.env.REACT_APP_API_URL?.trim();
const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);

let baseURL;
if (isLocal) {
  baseURL = envBase || 'http://127.0.0.1:8000/api';
} else {
  baseURL = envBase || 'https://api.complain-ai.app/api';
}

console.log('[API] Base URL:', baseURL);

const api = axios.create({
  baseURL: baseURL,
});

// Request interceptor - add JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Sending token:', !!token);
    } else {
      console.warn('No token found in localStorage');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle 401 (token expired)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('[API Error]', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.message,
      data: error.response?.data
    });
    
    const status = error.response?.status;
    const code = error.response?.data?.code;
    
    if (status === 401 && code === 'token_not_valid') {
      console.warn('Token invalid, clearing auth...');
      localStorage.removeItem('token');
      localStorage.removeItem('refresh');
      localStorage.removeItem('userInfo');
      window.location.href = '/';
    }
    
    return Promise.reject(error);
  }
);

export default api;
